'use client';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Compound member of <FieldSet>. Renders an error message with aria-live="polite"
 * so async error appearance is announced by assistive technology.
 */
export function FieldSetError({ id, children }) {
    return (_jsx("span", { id: id, "aria-live": "polite", style: { font: 'var(--type-caption)', color: 'var(--destructive)' }, children: children }));
}
//# sourceMappingURL=FieldSetError.js.map